import { baseUrl } from "../../../../boot";
import axios from "axios";

export const createQuote = async (formData) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}crm/api/v1/create-quotation`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}




export const deleteQuote = async (ROWID) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.delete(`${baseUrl}crm/api/v1/delete-quotation/${ROWID}`, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}

// update leads
export const updateQuote = async (ROWID, data) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.put(`${baseUrl}crm/api/v1/update-quotation/${ROWID}`, data, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}


// total count
export const countQuote = async (formData) => {
  console.log(formData,"count")
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}crm/api/v1/get-quotations-count`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}

export const getQuoteDetailById = async (id) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}crm/api/v1/get-quotation-by-id/${id}`, {
      headers: {
        "auth-token": token,
      }
    })
    // console.log('<<<<<<<<<<<<<<<<<<<<<companires>>>>>>>>>>>>>>>>>',response)
    return response
  } catch (error) {
    throw error
  }
}


export const quoteConversionApi = async (formData) => {
  console.log("data ----", formData);
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}crm/api/v1/create-quotation-from-walkthrough`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}

// Add deal
export const getQuoteInDeal = async (formData) => {
  console.log("deal form data ---- ", formData);
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}crm/api/v1/get-quotation-by-deal`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}


// Add deal
export const getQuoteInWalkthrough = async (formData) => {
  console.log("deal form data ---- ", formData);
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}crm/api/v1/get-quotation-by-walkid`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}


// update leads
export const sendQuoteEmail = async (ROWID, data) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}crm/api/v1/send-quotation-mail/${ROWID}`, data, {
      headers: {
        "auth-token": token,
        'Content-Type': 'multipart/form-data',

      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}

export const approveQuote = async (ROWID)=>{
const token =localStorage.getItem("authtoken");
try{
 const response = await axios.get(`${baseUrl}crm/api/v1//get-quotation-approved/${ROWID}`, {}, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;

}catch(error){
  throw error
}
}
export const rejectQuote = async (ROWID)=>{
const token =localStorage.getItem("authtoken");
try{
 const response = await axios.get(`${baseUrl}crm/api/v1//get-quotation-rejected/${ROWID}`, {}, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;

}catch(error){
  throw error
}
}

// First, add this function to your notesApi.js file
export const getNotesByQuotation = async (quoteId) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(
      `${baseUrl}crm/api/v1/get-note-by-quotation`,
      { Quotation: quoteId },
      {
        headers: {
          "auth-token": token,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};


export const getCompanyByQuotation = async (companyId) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(
      `${baseUrl}crm/api/v1/get-Quotation-By-Company`,
      { companyId },
      {
        headers: {
          "auth-token": token,
        },
      }
    );

    return response;
  } catch (error) {
    throw error;
  }
};


export const getClientByQuotation = async (clientId) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(
      `${baseUrl}crm/api/v1/get-Quotation-By-Contact`,
      { clientId: clientId },
      {
        headers: {
          "auth-token": token,
        },
      }
    );

    return response;
  } catch (error) {
    throw error;
  }
};


export const getDealByQuotation = async (dealId) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(
      `${baseUrl}crm/api/v1/get-quotation-by-deal`,
      { dealId },
      {
        headers: {
          "auth-token": token,
        },
      }
    );

    return response;
  } catch (error) {
    throw error;
  }
};


//Zoho Books API Integration
export const addQuoteinZohoBooks = async (Id) => {
  console.log("zoho books quote form id ---- ", Id);
  // const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(`${baseUrl}zohoBooks/api/v1/quotes/${Id}`, {
      // headers: {
      //   "auth-token": token,
      // }
    },)
    console.log("zoho boooks response",response)
    return response;
  } catch (error) {
    throw error
  }
}

export const updateQuoteinZohoBooks = async (ROWID, data) => {
  console.log("c",data)
  // const ROWID = data.ROWID
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.put(`${baseUrl}zohoBooks/api/v1/quotes/${ROWID}`, data, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}